export default __webpack_public_path__ + "static/media/home1.db514970.jpg";